import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createCustomerProgram,
  getCustomerProgram,
} from "@/api/program-steps";

/**
 * POST /customer/program/{program_id}
 * Create a customer program
 */
export const useCreateCustomerProgram = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ programId, payload }: { programId: string; payload: object }) =>
      createCustomerProgram(programId, payload),
    onSuccess: (_, { programId }) => {
      // Invalidate the customer program query so that UI refreshes
      queryClient.invalidateQueries({ queryKey: ["customer-program", programId] });
      // Invalidate roles queries as customer setup affects available roles
      queryClient.invalidateQueries({ queryKey: ["program-roles", programId] });
    },
  });
};

/**
 * GET /customer/program/{program_id}
 * Get customer program data
 */
export function useGetCustomerProgram(programId: string) {
  return useQuery({
    queryKey: ["customer-program", programId],
    queryFn: () => getCustomerProgram(programId),
    enabled: !!programId,
  });
} 